import React, { useContext } from 'react';

import { Box, Typography } from '@mui/material';

import BodyPart from './BodyPart';

import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import { VisibilityContext } from 'react-horizontal-scrolling-menu';


import RightArrowIcon from '../assets/icons/icon_5.png';
import LeftArrowIcon from '../assets/icons/icon_4.png';

const LeftArrow = () => {
  const { scrollPrev } = useContext(VisibilityContext);
  return (
    <Typography onClick={() => scrollPrev()} className='left-arrow'>
      <img src={RightArrowIcon} alt="left_arrow" />
    </Typography>
  )
}

const RightArrow = () => {
  const { scrollNext } = useContext(VisibilityContext);
  return (
    <Typography onClick={() => scrollNext()} className='right-arrow'>
      <img src={LeftArrowIcon} alt="right_arrow" />
    </Typography>
  )
}

const HorizontalScrollBar = ({ data, bodyPart, setBodyPart }) => {
  return (
    <ScrollMenu RightArrow={RightArrow} LeftArrow={LeftArrow}>
      {data.map((item) => (
        <Box 
          key={item.id || item}
          itemID={item.id || item}
          title={item.id || item} 
          m='0 40px'
        >
          <BodyPart item={item} bodyPart={bodyPart} setBodyPart={setBodyPart}/>
        </Box>
      ))}
    </ScrollMenu>
  )
}

export default HorizontalScrollBar